/* eslint-disable */

import axios from "axios";
import { showAlert } from "./utils";
// type is either password or data
export const updateSettings = async (data, type) => {
  try {
    let url;
    switch (type) {
      case "brugerdata":
        url = "/api/v1/users/updateMe";
        break;
      case "password":
        url = "/api/v1/users/updateMyPassword";
        break;
      case "firmadata":
        url = "/api/v1/companies/updateMyCompany";
        break;
      default:
        break;
    }
    const res = await axios({
      method: "PATCH",
      url,
      data,
    });

    if (res.data.status === "success") {
      if (res.data.data?.requiresMicrosoft) { location.assign('/login'); return; }
      showAlert("success", `Opdaterede ${type.toUpperCase()}`);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};

export const checkBoxSettings = async (path, data, id) => {
  try {
    if (data.sms) {
      data.smsApiToken = prompt(
        "Copy-paste API-token til sms gatewayen her. Kontakt Teleplan hvis du ikk har fået en API-token til sms gatewayen"
      );
    }
    const url = `/api/v1/${path}/${id}`;
    const res = await axios({
      method: "PATCH",
      url,
      data,
    });

    if (res.data.status === "success") {
      const updated = path == "users" ? "bruger." : "firma.";
      showAlert("success", `Opdaterede ${updated}`);
      return true;
    }
  } catch (err) {
    showAlert("error", err.response?.data?.message || 'Indstillingen kunne ikke gemmes.');
  }
  return false;
};

export const resetPassword = async (data, token) => {
  try {
    const url = `/api/v1/users/resetPassword/${token}`;
    const res = await axios({
      method: "PATCH",
      url,
      data,
    });

    if (res.data.status === "success") {
      showAlert("success", `Password opdateret`);
    }
    window.setTimeout(() => {
      location.assign(res.data.data?.requiresMicrosoft ? '/login' : '/');
    }, 2000);
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};

export const toggleEnforceSSO = async () => {
  try {
    const res = await axios({
      method: "PATCH",
      url: "/api/v1/users/auth/microsoft/enforce",
    });
    if (res.data.status === "success") {
      showAlert("success", "SSO indstillinger opdateret");
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response?.data?.message || "Kunne ikke ændre SSO");
  }
};

export const disconnectSSO = async () => {
  try {
    const res = await axios({
      method: "DELETE",
      url: "/api/v1/users/auth/microsoft/disconnect",
    });
    if (res.data.status === "success") {
      showAlert("success", "SSO er fjernet");
      window.setTimeout(() => {
        location.assign('/login');
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response?.data?.message || "Kunne ikke fjerne SSO");
  }
};
